<template>
  <div @click="backWX()" class="container">
    <div class="qrcode" ref="qrCodeUrl"></div>
  </div>
</template>

<script>
  import QRCode from 'qrcodejs2'
  export default {
    data() {
      return {

      }
    },
    created() {

    },
    mounted() {
      // console.log(this.$route.params.qrcode)
      this.creatQrCode(this.$route.params.qrcode);
    },
    methods: {
      creatQrCode() {
        var $this=this
        setTimeout(function(){
          var qrcode = new QRCode($this.$refs.qrCodeUrl, {
            text: 'xxxx', // 需要转换为二维码的内容
            width: 250,
            height: 250,
            colorDark: '#000000',
            colorLight: '#ffffff',
            correctLevel: QRCode.CorrectLevel.H
          })
        },300)
      },
      backWX(){
        wx.miniProgram.navigateBack({
           delta: 1
        })
      },
    }
  }
</script>

<style lang="less" scoped="scoped">
  @vm_base: 1/750*100vw;
  .container{
    background: #000;
    width: 100%;
    height: 100vh;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .qrcode{
    border: 5*@vm_base solid #FFFFFF;
  }

</style>



// WEBPACK FOOTER //
// src/components/qrcode/qrcode.vue